var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-list"},[(_vm.pageType === 'summary')?_c('SummaryPage',{on:{"getPageType":_vm.getPageType}}):_vm._e(),(_vm.pageType === 'detail')?_c('DetailPage',{on:{"getPageType":_vm.getPageType}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }